export default "__VITE_ASSET__CXPA_agz__"